/**
 * @flow
 * @relayHash 93c1f7c56433e9b443e72cfb5ec4eb85
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SettingsContainer_viewer$ref = any;
export type Route_Settings_QueryVariables = {||};
export type Route_Settings_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SettingsContainer_viewer$ref
  |}
|};
export type Route_Settings_Query = {|
  variables: Route_Settings_QueryVariables,
  response: Route_Settings_QueryResponse,
|};
*/


/*
query Route_Settings_Query {
  viewer {
    ...SettingsContainer_viewer
    id
  }
}

fragment SettingsContainer_viewer on User {
  id
  first_name
  last_name
  company_name
  s_time_zone
  features {
    music_lists
    id
  }
  payment_methods(first: 99999) {
    edges {
      node {
        ... on SquarePaymentMethod {
          __typename
          id
          enabled
        }
        ... on CashPaymentMethod {
          __typename
          id
          enabled
          instructions
        }
        ... on CheckPaymentMethod {
          __typename
          id
          address
          enabled
          pay_to
        }
        ... on CustomPaymentMethod {
          __typename
          id
          enabled
          label
          instructions
        }
        ... on Node {
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PlaylistsContainer_viewer
  ...AvailabilityCheckerContainer_viewer
}

fragment PlaylistsContainer_viewer on User {
  id
  playlists(first: 99999) {
    edges {
      node {
        id
        can_edit
        title
        description
        num_songs
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AvailabilityCheckerContainer_viewer on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 99999,
  "type": "Int"
},
v2 = [
  v1
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "enabled",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "instructions",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "return_empty_connection",
  "value": true,
  "type": "Boolean"
},
v10 = {
  "kind": "Literal",
  "name": "visibility",
  "value": [
    "SHOW"
  ],
  "type": "[UserEventVisibility]"
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v13 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEvent",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [
              v0,
              v8
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          },
          v11,
          v12,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": v2,
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [
                      v8,
                      v11,
                      v12,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "all_day",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "location",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "room",
                        "args": null,
                        "storageKey": null
                      },
                      v0
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Route_Settings_Query",
  "id": null,
  "text": "query Route_Settings_Query {\n  viewer {\n    ...SettingsContainer_viewer\n    id\n  }\n}\n\nfragment SettingsContainer_viewer on User {\n  id\n  first_name\n  last_name\n  company_name\n  s_time_zone\n  features {\n    music_lists\n    id\n  }\n  payment_methods(first: 99999) {\n    edges {\n      node {\n        ... on SquarePaymentMethod {\n          __typename\n          id\n          enabled\n        }\n        ... on CashPaymentMethod {\n          __typename\n          id\n          enabled\n          instructions\n        }\n        ... on CheckPaymentMethod {\n          __typename\n          id\n          address\n          enabled\n          pay_to\n        }\n        ... on CustomPaymentMethod {\n          __typename\n          id\n          enabled\n          label\n          instructions\n        }\n        ... on Node {\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...PlaylistsContainer_viewer\n  ...AvailabilityCheckerContainer_viewer\n}\n\nfragment PlaylistsContainer_viewer on User {\n  id\n  playlists(first: 99999) {\n    edges {\n      node {\n        id\n        can_edit\n        title\n        description\n        num_songs\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AvailabilityCheckerContainer_viewer on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Route_Settings_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SettingsContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Route_Settings_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v0,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "company_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "features",
            "storageKey": null,
            "args": null,
            "concreteType": "Features",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "music_lists",
                "args": null,
                "storageKey": null
              },
              v0
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "payment_methods",
            "storageKey": "payment_methods(first:99999)",
            "args": v2,
            "concreteType": "PaymentMethodConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentMethodEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      v0,
                      v3,
                      {
                        "kind": "InlineFragment",
                        "type": "CustomPaymentMethod",
                        "selections": [
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          },
                          v5
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CheckPaymentMethod",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "address",
                            "args": null,
                            "storageKey": null
                          },
                          v4,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pay_to",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CashPaymentMethod",
                        "selections": [
                          v4,
                          v5
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "SquarePaymentMethod",
                        "selections": [
                          v4
                        ]
                      }
                    ]
                  },
                  v6
                ]
              },
              v7
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "payment_methods",
            "args": v2,
            "handle": "connection",
            "key": "SettingsContainer_payment_methods",
            "filters": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "playlists",
            "storageKey": "playlists(first:99999)",
            "args": v2,
            "concreteType": "PlaylistConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PlaylistEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Playlist",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "can_edit",
                        "args": null,
                        "storageKey": null
                      },
                      v8,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "num_songs",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "thumbnail",
                        "storageKey": "thumbnail(height:240,width:240)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 240,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 240,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "SongImage",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "width",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "height",
                            "args": null,
                            "storageKey": null
                          },
                          v0
                        ]
                      },
                      v3
                    ]
                  },
                  v6
                ]
              },
              v7
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "playlists",
            "args": v2,
            "handle": "connection",
            "key": "PlaylistsContainer_playlists",
            "filters": null
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCalendarContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              {
                "kind": "Literal",
                "name": "booking_status",
                "value": [
                  "BOOKED",
                  "INITIAL",
                  "CANCELED"
                ],
                "type": "[BookingStatus]"
              },
              v1,
              v9,
              v10
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v13
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCheckerContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              v1,
              v9,
              v10
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v13
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd6e7618f26f6638a3a90ed150548a77d';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/Route_Settings_Query.graphql.js